/******/ (() => { // webpackBootstrap
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.stickyButton = this.querySelector('[data-sticky-atc-button]');
    this.pricesContainer = this.querySelector('[data-sticky-atc-prices]');
    this.priceEl = this.querySelector('[data-sticky-atc-price]');
    this.comparePriceEl = this.querySelector('[data-sticky-atc-compare-price]');
    this.sectionId = this.dataset.sectionId;
    this.observer = null;

    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleVariantUpdated = this.handleVariantUpdated.bind(this);
    this.handleCartAdded = this.handleCartAdded.bind(this);
  }

  connectedCallback() {
    this.setupIntersectionObserver();
    this.stickyButton.addEventListener('click', this.handleAddClick);

    if (window.eventBus) {
      window.eventBus.on('variant:updated', this.handleVariantUpdated);
      window.eventBus.on('cart:added', this.handleCartAdded);
    }
  }

  disconnectedCallback() {
    this.stickyButton.removeEventListener('click', this.handleAddClick);

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (window.eventBus) {
      window.eventBus.off('variant:updated', this.handleVariantUpdated);
      window.eventBus.off('cart:added', this.handleCartAdded);
    }
  }

  setupIntersectionObserver() {
    const productSection = document.querySelector(`[data-section-id="${this.sectionId}"] .paymentButtonsWrapper`)
      || document.querySelector(`.paymentButtonsWrapper`);

    if (!productSection) return;

    this.observer = new IntersectionObserver((entries) => {
      this.handleIntersect(entries);
    }, { threshold: 0 });

    this.observer.observe(productSection);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      // Show sticky bar whenever the static ATC is not in viewport (above or below)
      if (!entry.isIntersecting) {
        this.show();
      } else {
        this.hide();
      }
    });
  }

  show() {
    if (this.classList.contains('sticky-atc--visible')) return;
    this.classList.add('sticky-atc--visible');
    this.adjustBackToTop(true);
  }

  hide() {
    if (!this.classList.contains('sticky-atc--visible')) return;
    this.classList.remove('sticky-atc--visible');
    this.adjustBackToTop(false);
  }

  adjustBackToTop(stickyVisible) {
    const backToTop = document.querySelector('back-to-top');
    if (!backToTop) return;
    if (!window.matchMedia('screen and (max-width: 749px)').matches) return;
    const barHeight = stickyVisible ? this.offsetHeight : 0;
    backToTop.style.transition = 'bottom 0.3s ease, transform 1s ease, opacity 1s ease';
    backToTop.style.bottom = stickyVisible ? (barHeight + 10) + 'px' : '';
  }

  handleAddClick(e) {
    e.preventDefault();
    const originalAddButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    if (originalAddButton && !originalAddButton.disabled) {
      originalAddButton.click();
    }
  }

  handleVariantUpdated(data) {
    if (data.sectionId !== this.sectionId) return;
    this.syncState();
  }

  handleCartAdded(data) {
    if (data.sectionId !== this.sectionId) return;
    // Brief visual feedback — button text already handled by proxy click
  }

  createMoneySpan(text) {
    const span = document.createElement('span');
    span.className = 'money';
    span.textContent = text;
    return span;
  }

  syncState() {
    // Sync price from the original product-information DOM
    const originalPrice = document.querySelector('#ProductPrice [data-price-text]');
    if (originalPrice && this.priceEl) {
      this.priceEl.textContent = '';
      this.priceEl.appendChild(this.createMoneySpan(originalPrice.textContent.trim()));
    }

    // Sync compare-at price
    const originalComparePrice = document.querySelector('#ComparePrice .money');
    if (originalComparePrice && originalComparePrice.textContent.trim()) {
      if (!this.comparePriceEl) {
        // Create compare price element if it didn't exist
        const span = document.createElement('span');
        span.className = 'sticky-atc__compare-price';
        span.setAttribute('data-sticky-atc-compare-price', '');
        span.appendChild(this.createMoneySpan(originalComparePrice.textContent.trim()));
        this.pricesContainer.insertBefore(span, this.priceEl);
        this.comparePriceEl = span;
      } else {
        this.comparePriceEl.textContent = '';
        this.comparePriceEl.appendChild(this.createMoneySpan(originalComparePrice.textContent.trim()));
        this.comparePriceEl.style.display = '';
      }
    } else if (this.comparePriceEl) {
      this.comparePriceEl.style.display = 'none';
    }

    // Sync button disabled state and text
    const originalAddButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    if (originalAddButton) {
      this.stickyButton.disabled = originalAddButton.disabled;
      const originalText = originalAddButton.querySelector('[data-add-to-cart-text]');
      if (originalText) {
        this.stickyButton.textContent = originalText.textContent.trim();
      }
    }
  }
}

customElements.define('sticky-atc', StickyAtc);

/******/ })()
;